import { useEffect } from "react";

function CloseAccountConfigStep({ closeConfiguration }) {
  useEffect(() => {
    closeConfiguration();
  }, [closeConfiguration]);

  return null;
}

export default CloseAccountConfigStep;
